import React from 'react'

import { notifyParent, STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'
import { TOAST_VARIANT_ERROR, toastShow } from 'mailup-web-components'

import getIntl from 'Helpers/intl'

import { type EntityOut } from 'Types/beFiltersApi'

const entityTypeLabelMap: Record<EntityOut['Type'], string> = {
  Trigger: 'Load.Common.AutomationTask',
  Workflow: 'Load.Common.WorkflowSingularUppercase',
  DynamicContent: 'Load.Common.DynamicContentSingleLowercase',
}

const getEntityUrl = (ent: EntityOut): string => {
  switch (ent.Type) {
    case 'Trigger':
      return `automation_app_redirector.aspx?r=${encodeURIComponent(`/automation/task/${ent.Id}`)}`
    case 'Workflow':
      return `automation_app_redirector.aspx?r=${encodeURIComponent(`/automation/workflow/${ent.Id}/edit`)}`
    case 'DynamicContent':
      return `/console/GestoreContenutiEsterni.aspx?idContenuto=${ent.Id}`
  }
}

export const notifyFilterInUse = (entities: EntityOut[]): void => {
  const intl = getIntl()
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const handleEntityClick = (ent: EntityOut) => () => {
    console.log(ent)
    notifyParent('setCurrentList', [ent.IdList, getEntityUrl(ent), true])
  }

  const currentListEntities = entities.filter((e) => e.IdList === idList)

  const otherLists = [
    ...new Set(
      entities.filter((e) => e.IdList !== idList).map((l) => l.IdList),
    ),
  ]

  toastShow(
    <div>
      <p>{intl.formatMessage({ id: 'Load.Filters.FilterNoDelteteMessage' })}</p>
      {currentListEntities.length > 0 && (
        <>
          <strong>
            {intl.formatMessage({ id: 'Load.Filters.FilterNoDelteteDescr' })}
          </strong>
          <ul>
            {currentListEntities.map((entity, idx) => (
              <li key={idx}>
                - {intl.formatMessage({ id: entityTypeLabelMap[entity.Type] })}:{' '}
                <a onClick={handleEntityClick(entity)}>
                  {entity.Id} - {entity.Name}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
      {otherLists.length > 0 && (
        <strong>
          {intl.formatMessage(
            {
              id: 'Load.Filters.FilterInUseErrorMessageOtherList',
            },
            {
              N: otherLists.join(', '),
            },
          )}
        </strong>
      )}
    </div>,

    TOAST_VARIANT_ERROR,
  )
}
